export const ATHLETE_WIDGET = {
  ACTION_TYPES: {
    noAthleteDisplay: 'noAthleteDisplay',
    onAthleteStatClick: 'onAthleteStatClick',
    fetchAthletesStatsGames: 'fetchAthletesStatsGames',
    onAthleteStatsGamesPopupClick: 'onAthleteStatsGamesPopupClick',
    statsScrolledHandler: 'statsScrolledHandler',
    statsPlayerScrollHandler: 'statsPlayerScrollHandler',
    onStatGameClick: 'onStatGameClick',
    onStatsGamePlayerPopupClick: 'onStatsGamePlayerPopupClick',
    onHighlightStatsCompetitionChange: 'onHighlightStatsCompetitionChange',
    onLastMatchClick: 'onLastMatchClick',
    onTrophyChange: 'onTrophyChange',
    fetchTrophyStats: 'fetchTrophyStats',
    onPlayerPopupClick: 'onPlayerPopupClick',
    tabChange: 'tabChange',
    trophyTabChange: 'trophyTabChange',
    fetchSeasonData: 'fetchSeasonData',
    fetchCareerStatsData: 'fetchCareerStatsData',
    onGameClick: 'onGameClick',
    careerStatsKeyChange: 'careerStatsKeyChange',
    marketNavigationClick: 'marketNavigationClick',
    statsTabChange: 'statsTabChange'
  },

   ANALYTICS: {
    ACTION_TYPES: {
      onAthleteDisplay: 'onAthleteDisplay',
      onTrophiesTabClick: 'onTrophiesTabClick',
      onTrophiesClick: 'onTrophiesClick',
      onAthleteStatsDetailsDisplay: 'onAthleteStatsDetailsDisplay',
      onStatsDetailsClick: 'onStatsDetailsClick',
      onStatsGameClick: 'onStatsGameClick',
      onStatsCompetitionClick: 'onStatsCompetitionClick',
      onTabClick: 'onTabClick',
      onStatsSeasonClick: 'onStatsSeasonClick',
      statsTabClick: 'statsTabClick'
    },

    TROPHIES_TAB: {
      club: 'club',
      international: 'international',
      personal: 'personal'
    },

    SECTION: {
      playerDetails: 'player-details',
      transferHistory: 'transfer-history',
      playerStats: 'player-stats'
    },

    GAME_SOURCES: {
      lastGames: 'last-games',
      stats: 'stats'
    },

     STATS: {
       CLICK_TYPE: {
         tab: 'tab',
         seeAll: 'see-all',
       }
     }
  },

  IMAGE_SIZE: {
    desktop: 236,
    mobile: 118,
  },

  PLAYER_DETAILS: {
    size : 40,
    logoSize: 56,
    smallViewLogoSize: 40,

    STATUS: {
      ACTIVE: 1,
      DEAD: 2,
      RETIRED: 3
    },

    ICON: {
      NAMES: {
        FREE_AGENT:'free-agent',
        DECEASED:'death',
        RETIRED_GOALKEEPER:'goalkeeper-retirement',
        RETIRED_PLAYER:'sport-retirement'
      }
    }
  },

  HEADER: {
    ABSENCE: {
      ICON_SIZE: 20,
      SMALL_VIEW_ICON_SIZE: 16,

      ICON_NAMES_SUSPENSION: {
        1: "gc-football-card-red",
        2: "gc-football-card-yellow",
        3: "gc-football-disciplinary"
      },

      ICON_NAMES_INJURY: {
        1: "gc-football-missing-injury",
        2: "gc-football-missing-commitments"
      }
    },

    IMAGE_SIZE: {
      MOBILE: 64,
      DESKTOP: 80
    }
  },

  FORMATION_ID: {
    coach: 16
  },

  MODULE: {
    GAMES_LIMIT: {
      MOBILE: 6,
      DESKTOP: 10
    }
  },

  HIGHLIGHTS_STATS: {
    ICONS: {
      competition: 16,
      stats: 34
    },

    CONTAINER: {
      menuBar: 48
    }
  },

  LAST_MATCHES: {
    GAMES_NUM_TO_COLLAPSE: 2,

    COLLAPSED_HEADERS: {
      ARROW_SIZE: {
        MOBILE: 16,
        DESKTOP: 24
      }
    },

    BADGES_TYPES: {
      empty: 'empty',
      logo: 'logo',
      text: 'text',
      rating: 'rating'
    }
  },

  TRANSFERS: {
    COMPETITOR_LOGO_SIZE: {
      small_view: 16,
      desktop: 32
    }
  },

  TROPHIES: {
    TROPHY_LOGO_SIZE: {
      width: 40,
      height: 40,
    },

    MENU_BAR_HEIGHT: 120,
    ROW_ENTITY_LOGO_SIZE: {
      desktop: 32,
      mobile: 24
    },

    HEADER: {
      COLUMN_ICON_SIZE: 16
    }
  },

  CAREER_STATS: {
    ROW_ENTITY_LOGO_SIZE: 32,

    HEADER: {
      COLUMN_ICON_SIZE: {
        SMALL_VIEW: 12,
        DESKTOP: 16
      }
    },
    DROPDOWN: {
      LOGO_SIZE: 20
    }
  },

  TABS: {
    INDEXES: {
      profile: 0,
      matches: 1,
      stats: 2,
    },

    NAMES: {
      profile: 'profile',
      matches: 'matches',
      stats: 'stats'
    }
  },

  STATS_TAB: {
    INDEXES: {
      season: 0,
      career: 1,
    },

    ANALYTICS_NAMES :{
      season: 'season',
      career: 'career'
    }
  },
  CONTAINER: {
    ITEMS: {
      athleteDetails: 'athleteWidgetDetails',
      oddsBy: 'oddsBy',
      athleteStats: 'athleteStats',
      externalAd_1: 'externalAd_1',
      athleteNextGame: 'athleteNextGame',
      athleteLastMatches: 'athleteLastMatches',
      athleteNews: 'athleteNews',
      athleteOutrights: 'athleteOutrights',
      athleteTransfers: 'athleteTransfers',
      athleteTrophies: 'athleteTrophies',
      externalAd_2: 'externalAd_2',
    },
  },

  STAT_TYPE: {
    cleanSheet: 232
  }
}
